import React, { useEffect, useRef, useState } from "react";
import Icon1 from "../icons/Icon";
import Tippy from "@tippyjs/react";
import SmallSpinner from "../loading/SmallSpinner";

function DropDownGPTS3({
  label = "",
  disabled = false,
  items = [],
  value = "",
  onChange = () => {},
  onSearchChange = () => {},
  onFetchNewOptions = () => {}, // Function to fetch more options
  loadingSearch = false,
  className = "",
  mandatory = false,
  debounceDelay = 500, // Default 500ms delay
  hasMoreOptions = false, // Flag to indicate if more options are available
  active_filter_inculdes = true,
  add_item = (value) => {},
  allow_new_items = false,
  display_redirect = false,
  transparent = true,
  useRedirect = () => {},
  resetValue = null,
}) {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [focus, setHasFocus] = useState(false);
  const searchTimeoutRef = useRef(null);
  const dropdownRef = useRef(null);
  const listRef = useRef(null);
  const [openUpwards, setOpenUpwards] = useState(null);
  const isMouseDownRef = useRef(false);

  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // If there's more space above than below, open upwards
      setOpenUpwards(spaceAbove > spaceBelow);
    }
  }, [isOpen]);

  const handleBlur = (e) => {
    // Only close if mouse is not currently held down
    if (!isMouseDownRef.current) {
      setIsOpen(false);
    }
  };

  const handleMouseDown = () => {
    isMouseDownRef.current = true;
  };

  const handleMouseUp = () => {
    isMouseDownRef.current = false;
  };

  useEffect(() => {
    const listElement = listRef.current;
    if (listElement) {
      listElement.addEventListener("mousedown", handleMouseDown);
      listElement.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      if (listElement) {
        listElement.removeEventListener("mousedown", handleMouseDown);
        listElement.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, [isOpen]);

  // Filter items based on the input query
  const filteredItems = active_filter_inculdes
    ? items.filter((item) =>
        item.label.toLowerCase().includes(query.toLowerCase())
      )
    : items;

  let has_value = value !== null && value !== undefined && value !== "";
  let disabled_classname =
    " outline-none ring-transparent border-neutral-300 border-1 bg-neutral-100 border-neutral-300 text-shadow_25";

  const handleSelect = (e, item) => {
    e.stopPropagation(); // Prevents parent click event from firing

    onChange(item);
    setQuery(""); // Clear query after selection
    setIsOpen(false);
    setHasFocus(false);
  };

  const handleInputChange = (e) => {
    if (disabled) return;
    setQuery(e.target.value);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set new timeout
    searchTimeoutRef.current = setTimeout(() => {
      onSearchChange && onSearchChange(e.target.value);
    }, debounceDelay);

    if (value) {
      onChange({
        target: {
          value: null,
        },
      }); // Reset selected value if a new query is being typed
    }
  };

  // Handle list scrolling to detect when user is near the end
  const handleListScroll = (e) => {
    if (!hasMoreOptions || loadingSearch) return;

    const { scrollTop, scrollHeight, clientHeight } = e.target;
    // If we're within 20px of the bottom
    if (scrollHeight - scrollTop - clientHeight < 20) {
      onFetchNewOptions();
    }
  };

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="flex flex-row gap-2 w-full">
      <div
        tabIndex={0}
        onBlur={handleBlur}
        onClick={(e) => {
          if (isOpen) {
            setIsOpen(false);
            dropdownRef.current?.blur();
          } else if (!disabled) {
            setIsOpen(true);
          }
        }}
        className={`
                         

          relative pointer-events-none  select-none     outline-none
 w-full    flex   ${has_value ? "items-end py-1" : "items-center py-1"}  min-h-11  h-11 rounded-xl shadow-sm ${disabled ? disabled_classname : value ? (transparent ? "" : "bg-white") : transparent ? "" : "bg-white"} 
      } sm:text-sm  ${isOpen || disabled ? "cursor-default" : "cursor-pointer"}  ${!disabled && isOpen ? "border-2 outline-1 outline-blue-100 border-blue-300 " : mandatory && !has_value ? "border-red-300 border-2 outline-1 outline-red-100" : "border    "} `}
      >
        <div className={` w-full`}>
          {has_value && (
            <div
              className={`absolute top-0 px-2 text-h6 
                ${isOpen ? "text-blue-400" : "text-gray-300"}   `}
            >
              {label}
            </div>
          )}
          {mandatory && !has_value && !isOpen && (
            <div
              className={`absolute top-0 justify-start h-full items-start   flex  py-0 flex-row right-8    text-white  text-h6 `}
            >
              <div className="bg-red-300 flex flex-row items-end rounded-b-lg  px-1 h-5 pb-0.5 ">
                {" "}
                Champ obligatoire
              </div>
            </div>
          )}
          {!isOpen && (
            <div className={`absolute top-1/3 right-3 `}>
              <Icon1
                icon_name="down"
                size={15}
                fill={mandatory && !has_value && !isOpen ? "red" : "grey"}
              />
            </div>
          )}{" "}
          {isOpen && (
            <div className={`absolute top-1/3 right-3 `}>
              <Icon1 icon_name="up" size={15} fill="grey" />
            </div>
          )}
          <input
            ref={dropdownRef}
            type="text"
            className={`w-full pointer-events-auto rounded-xl  px-2  outline-none transition ease-in-out duration-150`}
            placeholder={label}
            value={
              value !== null
                ? items.find((item) => item.value === value)?.label
                : query
            }
            disabled={disabled}
            onChange={handleInputChange}
            // onKeyDown={handleKeyDown}
            autoComplete="zzz"
          />
        </div>
        {isOpen && !disabled && (
          <ul
            ref={listRef}
            onScroll={handleListScroll}
            className={`absolute pointer-events-auto z-50 w-full  flex flex-col max-h-c300 p-2 border-1 border-shadow_10 bg-white shadow-xl  h-auto rounded-lg  text-base ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm  ${openUpwards ? "bottom-full mb-1" : "top-full mt-1"}`}
          >
            <div className="bg-neutral-50 px-2 w-fit py-1 rounded-md mb-2  flex flex-row items-center justify-between">
              <span className="text-h5 text-gray-500">
                {filteredItems.length} résultat
                {filteredItems.length > 1 ? "s" : ""}
              </span>
            </div>
            {value &&
              resetValue &&
              items.find((item) => item.value === value) && (
                <div className="bg-blue-50 px-2 py-2 rounded-md mb-2 w-full flex flex-row items-center justify-between">
                  <span className="text-h2 text-indigo-500 font-semibold">
                    {items.find((item) => item.value === value)?.label}
                  </span>
                  <div onClick={() => resetValue()} className="cursor-pointer">
                    <Icon1 icon_name="close" size={15} fill="grey"></Icon1>
                  </div>
                </div>
              )}
            {filteredItems.map((item, index) => (
              <li
                key={index}
                className={`cursor-pointer select-none relative rounded-lg py-2  pl-3 pr-9 ${
                  value !== null && value === item.value
                    ? "text-indigo-500 bg-blue-50 "
                    : "text-gray-900 hover:bg-indigo-10"
                }`}
                onClick={(e) => handleSelect(e, item)}
              >
                <div className="flex items-center">
                  <span
                    className={` block truncate ${
                      value !== null && value === item.value
                        ? "font-semibold"
                        : ""
                    }`}
                  >
                    {item.label}{" "}
                    {item.extra_label && (
                      <span
                        className={` ${item.type ? (item.type === "purple" ? "text-purple-400 bg-purple-50" : item.type === "indigo" ? "text-indigo-400 bg-indigo-50" : "text-blue-400 bg-blue-50") : "text-blue-400 bg-blue-50"}  font-light  rounded-full px-1 text-h4 ml-1`}
                      >
                        {item.extra_label}
                      </span>
                    )}
                  </span>
                </div>
                {value !== null && value === item.value ? (
                  <span className="absolute inset-y-0 right-0 flex items-center pr-4">
                    <svg
                      className="h-5 w-5 text-indigo-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                ) : null}
              </li>
            ))}
            {filteredItems.length === 0 && !loadingSearch && (
              <li className="cursor-default select-none relative py-2 pl-3 pr-9 text-gray-500">
                Aucun résultat trouvé
              </li>
            )}
            {loadingSearch && (
              <li className="cursor-default select-none relative  flex flex-row gap-2 py-2 pl-3 pr-9 text-gray-500">
                Récupération <SmallSpinner size={20} loading={true} />
              </li>
            )}
          </ul>
        )}{" "}
      </div>{" "}
      {allow_new_items && (
        <div
          onClick={(e) => {
            e.stopPropagation(); // Prevents parent click event from firing
            // if local text is not empty, add it as a new item
            if (query && query.length > 0) {
              add_item(query);
              setQuery("");
              setIsOpen(false);
              setHasFocus(false);
            }
          }}
          className={` w-c50 rounded-md border-1 bg-white p-3 flex flex-row items-center cursor-pointer hover:bg-neutral-100 justify-center`}
        >
          <Icon1 icon_name="plus" size={17} fill="grey" />
        </div>
      )}{" "}
      {display_redirect && (
        <div
          onClick={(e) => {
            e.stopPropagation(); // Prevents parent click event from firing
            // if local text is not empty, add it as a new item
            useRedirect();
          }}
          className={` w-c50 rounded-md border-1 bg-white p-3 flex flex-row items-center cursor-pointer hover:bg-neutral-100 justify-center`}
        >
          <Icon1 icon_name="open" size={17} fill="grey" />
        </div>
      )}
    </div>
  );
}

export default DropDownGPTS3;
